

export class SystemParameter {
    systemParameterId: string;
    code: string;
    description: string;
    value: string;
}


export class  SystemParameterSearchingCriteria{
    code: string;   
    description: string;
    value: string;
}
